/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { membershipResponseSchema } from './membershipResponseSchema';

export const bulkTeamActionResponseSchema = z.object({
  get membershipsCreated() {
    return z.array(membershipResponseSchema);
  },
  membershipsDeleted: z.array(z.int()),
  get membershipsUpdated() {
    return z.array(membershipResponseSchema);
  },
});
